// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-question-circle-filled-icon{font-size:112px;opacity:.5}", ""]);
// Exports
module.exports = exports;
